import type { DocumentNode } from '@apollo/client';
import { ApolloLink } from '@apollo/client';
import { visit } from 'graphql';

/**
 * The curated API rejects `__typename` anywhere under `aggregations` ("Invalid aggregation field: __typename"), and
 * Apollo adds one to every selection set, so this removes those before the request goes out. Apollo needs
 * `__typename` to read a fragment back, so a fragment under `aggregations` is refused rather than returned empty.
 */
export const stripAggregationTypenameLink = new ApolloLink((operation, forward) => {
  operation.query = stripAggregationTypename(operation.query);
  return forward(operation);
});

export function stripAggregationTypename(document: DocumentNode): DocumentNode {
  let depth = 0;
  const refuseFragment = () => {
    if (depth > 0) throw new Error('Select fields under aggregations directly; a fragment there reads back empty.');
  };
  return visit(document, {
    Field: {
      enter: node => {
        if (node.name.value === 'aggregations') depth += 1;
        else if (depth > 0 && node.name.value === '__typename') return null;
        return undefined;
      },
      leave: node => {
        if (node.name.value === 'aggregations') depth -= 1;
      },
    },
    FragmentSpread: refuseFragment,
    InlineFragment: refuseFragment,
  });
}
